module.exports = __webpack_public_path__ + "static/stacheldraht_gr@2x.160039ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Stacheldraht/stacheldraht_gr@2x.png
// module id = 442
// module chunks = 35783957827783